<script>
  import { onMount } from "svelte";
  import { locales, setLocale, getLocale } from "../lib/i18n.svelte.js";

  let open = $state(false);
  let btnEl = $state(null);
  let openUp = $state(false);
  let current = $derived(locales.find((l) => l.code === getLocale()) || locales[0]);

  function handleWindowClick() {
    if (open) open = false;
  }

  function toggle(e) {
    e.stopPropagation();
    // Decide direction based on button position
    if (btnEl) {
      const rect = btnEl.getBoundingClientRect();
      openUp = rect.bottom > window.innerHeight - 200;
    }
    open = !open;
  }

  onMount(() => {
    window.addEventListener("click", handleWindowClick);
    return () => window.removeEventListener("click", handleWindowClick);
  });
</script>

<div class="relative z-[300] isolate">
  <button
    type="button"
    bind:this={btnEl}
    onclick={toggle}
    class="relative z-[10] flex items-center gap-1.5 px-2 py-1 text-sm text-zinc-400 hover:text-white rounded hover:bg-white/[0.06] transition-colors"
  >
    <span>{current.flag}</span>
    <span class="hidden sm:inline">{current.code.toUpperCase()}</span>
  </button>

  {#if open}
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      class="absolute right-0 z-[5] min-w-[140px] rounded border ui-dropdown p-1 shadow-xl {openUp ? 'bottom-full mb-1' : 'top-full mt-1'}"
      onclick={(e) => e.stopPropagation()}
    >
      {#each locales as locale}
        <button
          type="button"
          onclick={() => {
            setLocale(locale.code);
            open = false;
          }}
          class="flex items-center gap-2 w-full px-3 py-2 text-sm text-left rounded hover:bg-white/[0.08] transition-colors {locale.code === current.code ? 'text-white' : 'text-zinc-400'}"
        >
          <span>{locale.flag}</span>
          <span>{locale.name}</span>
        </button>
      {/each}
    </div>
  {/if}
</div>
